import _ from 'lodash'

// eslint-disable-next-line
export function reduceProvider(data, selector, intl, type) {
    return _.reduce(
        data,
        (result, value) => {
            const valObj = value[selector]

            if (!valObj) return result

            if (type === 'money') {
                const formattedAmount = valObj.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
                const currency = intl.formatMessage({ id: `global.currency.${valObj?.currency || 'CZK'}` })

                return {
                    ...result,
                    [value.providerId]: `${formattedAmount} ${currency}`,
                }
            }

            if (type === 'date') {
                return {
                    ...result,
                    [value.providerId]: valObj.join(','),
                }
            }

            return {
                ...result,
                [value.providerId]: valObj,
            }
        },
        {}
    )
}
